import { z } from 'zod/v4';

export const ManufacturingSourcingCacheLastRefreshRuntime = z.object({
    time: z.string().nullable(),
});
